<template>
	<LoginLayout>
		<div 
			class="tw-min-h-screen tw-flex tw-items-center tw-justify-center tw-relative tw-overflow-hidden"
			:style="{
				backgroundImage: 'url(\'@/assets/images/post-cloud.png\')',
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundAttachment: 'fixed'
			}"
		>
			<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-from-white/80 tw-to-slate-50/75'" class="tw-absolute tw-inset-0"></div>		
				<div class="tw-absolute tw-top-6 tw-right-6 tw-z-10">
					<button 
						@click="toggleTheme" 
						class="tw-p-2 tw-rounded-full hover:tw-bg-white/10 tw-relative tw-w-10 tw-h-10 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
					>
						<transition name="theme-fade">
							<svg 
								v-if="theme === 'dark'"
								key="sun"
								xmlns="http://www.w3.org/2000/svg" 
								class="tw-w-6 tw-h-6 tw-absolute tw-stroke-white" 
								fill="none" 
								viewBox="0 0 24 24" 
								stroke-width="2"
							>
								<path stroke-linecap="round" stroke-linejoin="round" d="M12 3v2.25m0 13.5V21m8.966-8.966h-2.25M5.25 12H3m14.593-7.343l-1.591 1.591M6.75 17.25l-1.591 1.591M17.25 17.25l1.591 1.591M6.75 6.75L5.159 5.159M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
							</svg>

							<svg 
								v-else
								key="moon"
								xmlns="http://www.w3.org/2000/svg" 
								class="tw-w-6 tw-h-6 tw-absolute tw-stroke-black" 
								fill="none" 
								viewBox="0 0 24 24" 
								stroke-width="2"
							>
								<path stroke-linecap="round" stroke-linejoin="round" d="M21.752 15.002A9.718 9.718 0 0118 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 003 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 009.002-5.998z" />
							</svg>
						</transition>
					</button>
				</div>
					<div class="tw-relative tw-w-full tw-flex tw-items-center tw-justify-center tw-px-4">
				<div class="tw-w-full tw-max-w-md">
					<div class="tw-text-center tw-mb-10">
						<div class="tw-inline-flex tw-items-center tw-justify-center tw-w-18 tw-h-18 tw-mb-6">
							<img src="/logo.ico" alt="Winckieel Logo" class="tw-w-16 tw-h-16 tw-object-contain" />
						</div>
						<h1 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-4xl tw-font-bold tw-tracking-tight">{{ vue_app_name }}</h1>
						<p :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-text-sm tw-mt-2 tw-font-medium">Sistema de Gerenciamento em Nuvem</p>
					</div>
					<div :class="theme === 'dark' ? 'tw-bg-[#151515]/95' : 'tw-bg-white/95'" class="tw-rounded-2xl tw-p-8 tw-shadow-2xl tw-backdrop-blur-sm">
						<form @submit.prevent="authLoginSubmit" class="tw-space-y-6">
							<div>
								<label for="usuario" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-block tw-text-sm tw-font-semibold tw-mb-2">
									Usuário
								</label>
								<input
									v-model="usuario"
									type="text"
									id="usuario"
									name="usuario"
									:disabled="disabled"
									:class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white placeholder:tw-text-slate-500 focus:tw-ring-slate-50' : 'tw-bg-slate-50 tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-ring-[#33b35a]'"
									class="tw-w-full tw-rounded-xl tw-px-4 tw-py-3 tw-text-sm focus:tw-ring-1 focus:tw-border-transparent disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
									placeholder="seu.usuario"
									autocomplete="username"
								/>
							</div>
							<div>
								<label for="senha" :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-block tw-text-sm tw-font-semibold tw-mb-2">
									Senha
								</label>
								<div class="tw-relative">
									<input
										v-model="senha"
										:type="mostrarSenha ? 'text' : 'password'"
										id="senha"
										name="senha"
										:disabled="disabled"
										:class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-white placeholder:tw-text-slate-500 focus:tw-ring-slate-50' : 'tw-bg-slate-50 tw-text-slate-900 placeholder:tw-text-slate-400 focus:tw-ring-[#33b35a]'"
										class="tw-w-full tw-rounded-xl tw-px-4 tw-py-3 tw-pr-12 tw-text-sm focus:tw-ring-1 focus:tw-border-transparent disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
										placeholder="••••••••"
										autocomplete="current-password"
									/>
									<button
										type="button"
										@click="mostrarSenha = !mostrarSenha"
										:disabled="disabled"
										class="tw-absolute tw-right-4 tw-top-1/2 tw-transform tw--translate-y-1/2 tw-text-slate-500 hover:tw-text-slate-700 disabled:tw-opacity-50"
									>
									</button>
								</div>
								
								<div class="tw-flex tw-items-center tw-mt-3">
									<input
										type="checkbox"
										id="mostrarSenha"
										v-model="mostrarSenha"
										:disabled="disabled"
										:class="theme === 'dark' ? 'tw-accent-[#33b35a]' : 'tw-accent-[#33b35a]'"
										class="tw-hidden tw-w-4 tw-h-4 tw-rounded tw-border disabled:tw-opacity-50"
									/>
									<label for="mostrarSenha" :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-ml-2.5 tw-text-sm tw-cursor-pointer tw-select-none">
										{{ mostrarSenha ? 'Ocultar senha' : 'Mostrar senha' }}
									</label>
								</div>
							</div>
							<div class="tw-pt-4">
								<button 
									v-if="!login"
									type="submit" 
									:disabled="disabled"
									class="tw-w-full tw-bg-[#33b35a] hover:tw-bg-[#2d9d4f] tw-text-white tw-font-semibold tw-py-3 tw-px-4 tw-rounded-xl tw-shadow-lg hover:tw-shadow-xl focus:tw-ring-4 focus:tw-ring-[#33b35a]/30 disabled:tw-opacity-50 disabled:tw-cursor-not-allowed"
								>
									Acessar
								</button>
								<ButtonLoading v-else class="tw-w-full tw-h-12" />
							</div>
						</form>
						<div :class="theme === 'dark' ? 'tw-border-slate-700' : 'tw-border-slate-200'" class="tw-text-center tw-mt-6 tw-pt-6 tw-border-t">
							<button
								type="button"
								@click="showSupportModal = true"
								:class="theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-[#2d9d4f]' : 'tw-text-slate-600 hover:tw-text-[#2d9d4f]'"
								class="tw-text-sm tw-font-semibold tw-underline"
							>
								Esqueceu sua senha?
							</button>
						</div>
					</div>
					<div class="tw-text-center tw-mt-8">
						<p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-xs">
							<span class="tw-font-semibold">Versão v{{ version }}</span>
						</p>
						<p :class="theme === 'dark' ? 'tw-text-slate-500' : 'tw-text-slate-500'" class="tw-text-xs tw-mt-1">© 2026 Winckieel. Todos os direitos reservados.</p>
					</div>
				</div>
			</div>
		</div>
		<div v-if="showSupportModal" class="tw-backdrop-blur-sm tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-items-center tw-justify-center tw-z-50 tw-p-4">
			<div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-white'" class="tw-rounded-2xl tw-shadow-2xl tw-max-w-md tw-w-full tw-p-8">
				<div class="tw-flex tw-items-center tw-justify-between tw-mb-6">
					<h2 :class="theme === 'dark' ? 'tw-text-white' : 'tw-text-slate-900'" class="tw-text-2xl tw-font-bold">
						Recuperar Acesso
					</h2>
					<button
						@click="showSupportModal = false"
						:class="theme === 'dark' ? 'tw-text-slate-400 hover:tw-text-white' : 'tw-text-slate-400 hover:tw-text-slate-900'"
						class="tw-text-2xl"
					>
						✕
					</button>
				</div>
				<div :class="theme === 'dark' ? 'tw-text-slate-300' : 'tw-text-slate-700'" class="tw-mb-8 tw-space-y-4">
					<p class="tw-text-sm">
						Para recuperar sua senha, entre em contato com nosso suporte via WhatsApp.
					</p>
					<div :class="theme === 'dark' ? 'tw-bg-slate-800' : 'tw-bg-slate-50'" class="tw-rounded-lg tw-p-4 tw-text-center">
						<p :class="theme === 'dark' ? 'tw-text-slate-400' : 'tw-text-slate-600'" class="tw-text-xs tw-mb-3">
							Número de Suporte:
						</p>
						<a
							:href="suporteWhatsappLink"
							target="_blank"
							rel="noopener noreferrer"
							class="tw-text-lg tw-font-bold tw-text-[#25D366] hover:tw-text-[#1ead50] tw-break-all"
						>
							{{ numeroSuporteWhatsapp }}
						</a>
					</div>
				</div>
				<div class="tw-space-y-3">
					<a
						:href="suporteWhatsappLink"
						target="_blank"
						rel="noopener noreferrer"
						class="tw-w-full tw-flex tw-items-center tw-justify-center tw-gap-2 tw-bg-[#25D366] hover:tw-bg-[#1ead50] tw-text-white tw-font-semibold tw-py-3 tw-px-4 tw-rounded-xl tw-shadow-lg hover:tw-shadow-xl"
					>
						Contato via WhatsApp
					</a>
					<button
						@click="showSupportModal = false"
						:class="theme === 'dark' ? 'tw-bg-slate-800 hover:tw-bg-slate-700 tw-text-slate-300' : 'tw-bg-slate-100 hover:tw-bg-slate-200 tw-text-slate-900'"
						class="tw-w-full tw-font-semibold tw-py-3 tw-px-4 tw-rounded-xl"
					>
						Fechar
					</button>
				</div>
			</div>
		</div>
	</LoginLayout>
</template>

<script>
	import { useStore } from "vuex";
	import { useRouter } from "vue-router";
	import { ref } from "vue";
	import { useToast } from 'vue-toastification';
	import { mapState, mapActions } from 'vuex';
	import LoginLayout from "@/components/layouts/LoginLayout.vue";
	import ButtonLoading from "@/components/ui/ButtonLoading.vue";

	export default {
		name: "LoginPage",
		components: {
			LoginLayout,
			ButtonLoading
		},
		setup() {
			const store = useStore();
			const router = useRouter();
			const usuario = ref();
			const senha = ref();
			const toast = useToast();
			const version = process.env.VUE_APP_VERSION;
			const vue_app_name = process.env.VUE_APP_NAME;
			const login = ref(false);
			const disabled = ref(false);
			const mostrarSenha = ref(false);
			const showSupportModal = ref(false);
			const numeroSuporteWhatsapp = process.env.VUE_APP_WHATSAPP_SUPORTE || "55 (XX) XXXXX-XXXX";
			const suporteWhatsappLink = `https://wa.me/${numeroSuporteWhatsapp}?text=${encodeURIComponent("Olá, esqueci minha senha da Winckieel Cloud e gostaria de recuperar meu acesso.")}`;

			const authLoginSubmit = async () => {
				login.value = true;
				disabled.value = true;

				try {
					await store.dispatch("auth/login", {
                        "usuario": usuario.value,
                        "senha": senha.value
                    });
					router.push("/v2/unidades");
					toast.success("Usuário autenticado com sucesso", {timeout: 2000})
				} catch (error) {
					login.value = false;
					disabled.value = false;
					console.error("Erro de autenticação:", error);
					toast.error("Erro de autenticação: verifique suas credenciais.")
				}
			};

			return {
				usuario,
				senha,
				authLoginSubmit,
				version,
				vue_app_name,
				login,
				disabled,
				mostrarSenha,
				showSupportModal,
				numeroSuporteWhatsapp,
				suporteWhatsappLink
			};
		},
		computed: {
			...mapState({
				theme: state => state.ui.theme,
			}),
		},
		methods: {
			...mapActions('ui', ['toggleTheme']),
		}
	};
</script>

<style scoped>

input[type="text"],
input[type="password"] {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
}

input[type="checkbox"] {
	appearance: none;
	-webkit-appearance: none;
	-moz-appearance: none;
	cursor: pointer;
}

input:focus,
button:focus {
	outline: none;
}

.theme-fade-enter-active,
.theme-fade-leave-active {
	transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.theme-fade-enter-from {
	transform: rotate(-90deg) scale(0);
	opacity: 0;
}

.theme-fade-leave-to {
	transform: rotate(90deg) scale(0);
	opacity: 0;
}


.tw-backdrop-blur-sm {
	backdrop-filter: blur(8px);
}
</style>
